import { defineMessages } from 'react-intl';

const _default_1: {
	presentationText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectSelectorLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releaseDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearChooseDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openCalendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createVersionHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateValidationError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameValidationError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createReleaseSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	presentationText: {
		id: 'ai-mate.message-actions.jira-version-create.presentationText',
		defaultMessage:
			'I have drafted a new release for you. Please review the information below to create your new release.',
		description:
			'Text shown as an introductory paragraph at the top of the create release modal in Rovo chat, informing the user that a draft release has been prepared for review.',
	},
	projectSelectorLabel: {
		id: 'ai-mate.message-actions.jira-version-create.project-selector.label.non-final',
		defaultMessage: 'Space',
		description: 'Label for the project selector field in the release creation form in Rovo chat',
	},
	nameLabel: {
		id: 'ai-mate.message-actions.jira-version-create.nameLabel',
		defaultMessage: 'Name', // TODO: Update this to "Release name" when the feature is released
		description:
			'Text shown as the field label for the release name input in the create release form within Rovo chat.',
	},
	descriptionLabel: {
		id: 'ai-mate.message-actions.jira-version-create.descriptionLabel',
		defaultMessage: 'Description',
		description:
			'Text shown as the field label for the optional description input in the create release form within Rovo chat.',
	},
	startDateLabel: {
		id: 'ai-mate.message-actions.jira-version-create.startDateLabel',
		defaultMessage: 'Start Date',
		description:
			'Text shown as the field label for the start date picker in the create release form within Rovo chat.',
	},
	releaseDateLabel: {
		id: 'ai-mate.message-actions.jira-version-create.releaseDateLabel',
		defaultMessage: 'Release Date',
		description:
			'Text shown as the field label for the release date picker in the create release form within Rovo chat.',
	},
	clearChooseDate: {
		id: 'ai-mate.message-actions.jira-version-create.clearChooseDate',
		defaultMessage: 'Clear choose date',
		description:
			'Text shown as the accessible label for a button inside the date picker in the create release form that removes any currently selected date.',
	},
	openCalendar: {
		id: 'ai-mate.message-actions.jira-version-create.openCalendar',
		defaultMessage: 'Open calendar',
		description:
			'Text shown as the accessible label for a button inside the date picker in the create release form that opens the calendar overlay for date selection.',
	},
	createVersionHeading: {
		id: 'ai-mate.message-actions.jira-version-create.createVersionHeading',
		defaultMessage: 'Create release',
		description:
			'Text shown as the heading at the top of the create release action card in Rovo chat.',
	},
	dateValidationError: {
		id: 'ai-mate.message-actions.jira-version-create.dateValidationError',
		defaultMessage: 'The start date cannot be after the release date.',
		description:
			'Text shown as an inline validation error below the date fields in the create release form when the user enters a start date that falls after the release date.',
	},
	nameValidationError: {
		id: 'ai-mate.message-actions.jira-version-create.nameValidationError',
		defaultMessage: 'Enter a name.',
		description:
			'Text shown as an inline validation error below the name field in the create release form when the user submits the form without entering a release name.',
	},
	createReleaseSelected: {
		id: 'ai-mate.message-actions.jira-version-create.createReleaseSelected',
		defaultMessage: 'You selected "Create Release"',
		description:
			'Text shown as a confirmation message in the chat after the user selects the create release action from the action card in Rovo chat.',
	},
});
export default _default_1;
